module.exports = "/_next/static/images/main-visual-login-ee20e9c6c4bc00766ec0a2be5a23dfc2.jpg";